import { render, staticRenderFns } from "./JoinRequest.vue?vue&type=template&id=7dddd16e"
import script from "./JoinRequest.vue?vue&type=script&lang=js"
export * from "./JoinRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports